import "./LanguageSwitcher.scss";
import { useTranslation } from "react-i18next";


const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  // get the current language
  const currentLanguage = i18n.language;

  const handleLanguageChange = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="lang-switcher">
      <button
        className={`lang-switch__btn ${currentLanguage.startsWith("en") ? "active" : ""}`}
        onClick={() => handleLanguageChange("en")}
      >
        English
      </button>

      <span className="divider">|</span>

      <button
        className={`lang-switch__btn ${currentLanguage.startsWith("ja") ? "active" : ""}`}
        onClick={() => handleLanguageChange("ja")}
      >
        日本語
      </button>
      
    </div>
  );
};

export default LanguageSwitcher;
